import * as t from './actionTypes';
import { uploadEventRequest, uploadEventResponse } from './actions';
import type { DemoDataReducerState } from './types';

type DemoDataReducerActionType =
  | ReturnType<typeof uploadEventRequest>
  | ReturnType<typeof uploadEventResponse>;

export const initialState: DemoDataReducerState['baus']['demoData'] = {
  isLoading: false,
};

export const demoDataReducer = (state = initialState, action: DemoDataReducerActionType) => {
  switch (action.type) {
    case t.UPLOAD_EVENT_REQUEST: {
      return {
        isLoading: true,
      };
    }
    case t.UPLOAD_EVENT_RESPONSE: {
      return {
        isLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};
